import styled, { css } from 'styled-components'

import { ITooltipProps } from './Tooltip.component'

export const TooltipWrapper = styled.div`
    position: relative;
    width: content-fit;
`

export const Tip = styled.div<ITooltipProps>(({ placement, text, open = false }) => {
    const baseStyles = css`
        background-color: ${props => props.theme.color.offBlack};
        border: ${props => `1px solid ${props.theme.color.blueDarkGray}`};
        border-radius: 4px;
        color: #ffffff;
        content: '${text}';
        font-size: 12px;
        padding: 3px 9px;
        min-width: 100%;
        position: absolute;
        text-align: center;
        width: fit-content;
        z-index: 1;
        opacity: ${open ? 1 : 0};
        white-space: nowrap;
    `

    const arrow = css`
        border-bottom-color: transparent;
        border-left-color: transparent;
        border-right-color: transparent;
        border-style: solid;
        border-top-color: transparent;
        border-width: 10px;
        content: '';
        opacity: 0;
    `

    const placementStyles = {
        bottomCenter: css`
            :before {
                position: absolute;
                left: 50%;
                top: 35px;
                transform: translateX(-50%);
                ${arrow}
                border-bottom-color: #003750;
            }
            :after {
                ${baseStyles}
                left: 50%;
                top: 50px;
                transform: translateX(-50%);
            }
        `,
        bottomEnd: css`
            :before {
                position: absolute;
                right: 50%;
                top: 35px;
                ${arrow}
                border-bottom-color: #003750;
            }
            :after {
                ${baseStyles}
                right: 0;
                top: 50px;
            }
        `,
        bottomStart: css`
            :before {
                left: 50%;
                position: absolute;
                top: 35px;
                ${arrow}
                border-bottom-color: #003750;
            }
            :after {
                ${baseStyles}
                left: 0;
                top: 50px;
            }
        `,
        rightCenter: css`
            :before {
                ${baseStyles}
                left: 100%;
                top: 50%;
                transform: translateY(-50%);
            }
            :after {
                position: absolute;
                right: 0;
                top: 50%;
                ${arrow}
                transform: translateY(-50%);
                border-width: 5px;
                border-right-color: #003750;
            }
        `,
        topCenter: css`
            :before {
                ${baseStyles}
                left: 50%;
                top: -30px;
                transform: translateX(-50%);
            }
            :after {
                position: absolute;
                left: 50%;
                top: -15px;
                transform: translateX(-50%);
                ${arrow}
                border-top-color: #003750;
            }
        `,
        topEnd: css`
            :before {
                ${baseStyles}
                right: 0;
                top: -30px;
            }
            :after {
                position: absolute;
                right: 50%;
                top: -15px;
                ${arrow}
                border-top-color: #003750;
            }
        `,
        topStart: css`
            :before {
                ${baseStyles}
                left: 0;
                top: -30px;
            }
            :after {
                position: absolute;
                left: 50%;
                top: -15px;
                ${arrow}
                border-top-color: #003750;
            }
        `,
    }

    return css`
        position: relative;
        &:hover {
            &::before,
            &::after {
                opacity: 1;
            }
        }
        &::before,
        &::after {
            pointer-events: none;
        }
        ${placementStyles[placement]};
    `
})

export const Content = styled.div``
